import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { CtaButton } from './CtaButton';
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-255" data-mp="3ksqf566jze6h">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-256" data-mp="3b0ufhqotjg05" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-cream px-4 py-14" data-id="element-257" data-mp="370k9ie110pla">
      <div className="mx-auto max-w-4xl" data-id="element-258" data-mp="3205yqo81j1jk">
        <div className="text-center" data-id="element-259" data-mp="31z37gf6t2x34">
          <h2 className="font-serif text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-260" data-mp="3228xbwn9e2zw">What women are saying</h2>
          <div className="mt-3 flex items-center justify-center gap-2" data-id="element-261" data-mp="2s28dm9lh9kv6">
            <Stars data-id="element-262" data-mp="2s431nws1pt3h" />
            <span className="font-bold text-ink" data-id="element-263" data-mp="v96jbxhmprie">4.9/5</span>
          </div>
          <p className="mt-2 text-[15px] text-muted" data-id="element-264" data-mp="v72jprqrjenx">Women who have started transforming their nighttime routines</p>
        </div>

        <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-265" data-mp="h5ezbmd4bx17">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-5 shadow-[0_8px_30px_-14px_rgba(29,35,82,0.3)]" data-id="element-266" data-mp="m5kl4lwpipbd">
              <div className="flex items-center gap-4" data-id="element-267" data-mp="7928cw8yjxa5">
                <img src={t.photo} alt={`Photo of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-lavender" loading="lazy" data-id="element-268" data-mp="c6v9vbzbg343" />
                <div data-id="element-269" data-mp="zwy1jqzbj726">
                  <p className="font-bold text-ink" data-id="element-270" data-mp="zyscccgvlisj">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-271" data-mp="14u7pt3az1cof">{t.flag} {t.country}</p>
                  <Stars data-id="element-272" data-mp="q7ejgnjfjh8d" />
                </div>
              </div>
              <blockquote className="mt-4 font-serif text-lg italic leading-relaxed text-ink" data-id="element-273" data-mp="v5psiw1whnpj">“{t.quote}”</blockquote>
            </li>)}
        </ul>

        <CtaButton className="mt-10" label="I want to feel this calm at night" data-id="element-274" data-mp="1itqvlpgb8bxk" />
      </div>
    </section>;
}